import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './tasks-simple.constants';
import * as types from './tasks-simple.types';
import * as services from './tasks-simple.saga-services';

function* invokeCreateTaskSimple(action: types.ICreateTaskSimple) {
  yield call(services.createTaskSimple, action.payload);
}
function* invokeCreateFormTaskSimple(action: types.ICreateFormTaskSimple) {
  yield call(services.createFormTaskSimple, action.payload);
}
function* invokeUpdateTaskSimple(action: types.IUpdateTaskSimple) {
  yield call(services.updateTaskSimple, action.payload.id, action.payload.data);
}
function* invokeUpdateFormTaskSimple(action: types.IUpdateFormTaskSimple) {
  yield call(services.updateGoal, action.payload);
}

function* invokeUpdateGoalStatus(action: types.IUpdateGoalAction) {
  yield call(services.updateGoalStatus, action.payload.id, action.payload.data);
}

function* invokeDeleteTaskSimple(action: types.IDeleteTaskSimple) {
  yield call(services.deleteTaskSimple, action.payload);
}
function* invokeAddTaskWatcher(action: types.IAddTaskWatcher) {
  yield call(services.addTaskWatcher, action.payload);
}
function* invokeDeleteTaskWatcher(action: types.IDeleteTaskWatcher) {
  yield call(services.deleteTaskWatcher, action.payload);
}

function* invokeAddTaskAttachment(action: types.IAddTaskAttachment) {
  yield call(services.addTaskAttachment, action.payload.id, action.payload.data);
}

function* invokeInitializeTaskProps(action: types.IInitializeTaskProps) {
  yield call(services.initializeTaskProps, action.payload);
}
function* invokeClearTaskProps(action: types.IClearTaskProps) {
  yield call(services.clearTaskProps);
}
function* invokeSaveTaskSocket(action: types.ISaveTaskSimpleSocket) {
  yield call(services.saveTaskSimpleSocket, action.payload);
}
function* invokeDeleteTaskSocket(action: types.IDeleteTaskSimpleSocket) {
  yield call(services.deleteTaskSimpleSocket, action.payload);
}
function* invokeSaveTaskOrderSocket(action: types.ISaveTaskOrderSocket) {
  yield call(services.saveTaskOrderSocket, action.payload);
}
function* invokeDndTask(action: types.IDndTask) {
  yield call(services.taskDnd, action.payload.result, action.payload.meetingId);
}
function* invokeSharedTask(action: types.ISharedTask) {
  yield call(services.setupSharedTask, action.payload);
}

export function* watchTasksSimplePurePageSaga() {
  yield takeLatest(constants.CREATE_TASK_SIMPLE, invokeCreateTaskSimple);
  yield takeLatest(constants.CREATE_FORM_TASK_SIMPLE, invokeCreateFormTaskSimple);
  yield takeLatest(constants.UPDATE_TASK_SIMPLE, invokeUpdateTaskSimple);
  yield takeLatest(constants.UPDATE_FORM_TASK_SIMPLE, invokeUpdateFormTaskSimple);
  yield takeLatest(constants.UPDATE_GOAL_STATUS, invokeUpdateGoalStatus);
  yield takeLatest(constants.DELETE_TASK_SIMPLE, invokeDeleteTaskSimple);
  yield takeLatest(constants.INITIALIZE_TASK_PROPS, invokeInitializeTaskProps);
  yield takeLatest(constants.CLEAR_TASK_PROPS, invokeClearTaskProps);
  yield takeLatest(constants.DND_TASK, invokeDndTask);
  yield takeLatest(constants.SAVE_TASK_ORDER_SOCKET, invokeSaveTaskOrderSocket);
  yield takeLatest(constants.GET_SHARED_TASK, invokeSharedTask);
  yield takeLatest(constants.ADD_ATTACHMENT, invokeAddTaskAttachment);
  yield takeLatest(constants.ADD_WATCHER, invokeAddTaskWatcher);
  yield takeLatest(constants.DELETE_WATCHER, invokeDeleteTaskWatcher);

  yield takeLatest(constants.SAVE_TASK_SIMPLE_SOCKET, invokeSaveTaskSocket);
  yield takeLatest(constants.DELETE_TASK_SIMPLE_SOCKET, invokeDeleteTaskSocket);
}

export function* watchTasksSimplePageStorageSaga() {
  yield all([watchTasksSimplePurePageSaga].map(fork));
}
